// lib
import * as R from "ramda";
// src
import { findBestColors } from "utils/colors";
import { mdissoc } from "utils/object";
import { asArray, getResourceType, getTypeFromId, join } from "utils/presets";
import { ResourceType } from "config/constants";

const formatForById = (preset) => {
  const { params, options } = preset;
  let resourceType = null;
  // ok if only one resource in params
  if (params && R.keys(params).length === 1) {
    if (params.courses) resourceType = ResourceType.COURSE;
    else if (params.people) resourceType = ResourceType.PERSON;
    else if (params.projects) resourceType = ResourceType.COURSE;
    else if (params.groups) resourceType = ResourceType.GROUP;
    else if (params.rooms) resourceType = ResourceType.ROOM;
  } else if (options && options.type) {
    resourceType = getResourceType(options.type);
  }
  return resourceType ? { ...preset, resourceType } : preset;
};

// id arrays
export const addTo = (prevs, targets) => {
  const diffs = R.difference(asArray(targets), prevs);
  return [...prevs, ...diffs];
};

// id arrays
export const removeFrom = (prevs, targets) => {
  return R.difference(asArray(prevs), asArray(targets));
};

const equalsById = ({ id: id1 }, id2) => {
  return id1 === id2;
};

export const removeFromWithPreset = (prevs, targets) => {
  return R.differenceWith(equalsById, asArray(prevs), asArray(targets));
};

export const addToById = (byId, payload) => {
  const newByIds = asArray(payload)
    .map(formatForById)
    .reduce((acc, preset) => {
      // reject undefined values so they won't override existing ones
      const cleanedPreset = R.reject(R.isNil, preset);
      const { id, ...rest } = cleanedPreset;
      const type = cleanedPreset.type || getTypeFromId(id);
      acc[id] = { id, ...byId[id], ...rest, type };
      return acc;
    }, {});
  return { ...byId, ...newByIds };
};

export const addOneColorToById = (byId, { id }, color) => {
  const preset = byId[id];
  return { ...byId, [id]: { ...preset, color } };
};

export const addOneColorFromById = (byId, { id }) => {
  const { color, ...rest } = byId[id];
  return { ...byId, [id]: rest };
};

export const removeFromById = (byId, id) => {
  if (!id || R.isEmpty(id)) return byId;
  return Array.isArray(id) ? mdissoc(id, byId) : R.dissoc(id, byId);
};

export const addColorIfNeeded = (byId, ids) => {
  const targets = join(byId, asArray(ids));
  const targetsWithoutColor = R.filter(({ color }) => !color, targets);
  if (targetsWithoutColor.length < 1) return false;
  const usedColors = R.reduce(
    (acc, preset) => (preset.color ? R.append(preset.color, acc) : acc),
    [],
    R.values(byId),
  );
  const newColors = findBestColors(targetsWithoutColor.length, usedColors);
  return targetsWithoutColor.map((target, index) => ({
    id: target.id,
    color: newColors[index],
  }));
};
